import InternalUserInfo from "./InternalUserInfo";

export default InternalUserInfo;
